"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = function useStyles(props) {
  return (0, _styles.makeStyles)(function (theme) {
    return {
      CardContext: _objectSpread({
        border: '1px solid rgb(235,235,235)',
        borderRadius: '8px',
        minWidth: '300px',
        '&:first-child': {
          marginTop: '40px'
        }
      }, props.className),
      CardMain: {
        padding: '24px 16px',
        paddingBottom: props.paddingBottom
      },
      CardDetails: {
        color: 'rgba(0,0,0,.54)',
        fontSize: '16px',
        lineHeight: '150%'
      },
      CardFooter: {
        borderTop: '1px solid rgb(235,235,235)',
        padding: '12px 16px',
        height: '48px',
        color: props.color || theme.palette.secondary.main,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        '&:hover': {
          cursor: 'pointer',
          backgroundColor: 'rgba(0, 0, 0, 0.04)'
        },
        '&:focus': {
          cursor: 'pointer',
          backgroundColor: theme.palette.background.hover
        }
      },
      CardInteractive: {
        width: '100%',
        color: props.color || theme.palette.secondary.main
      },
      CardText: {
        fontWeight: 'normal',
        fontSize: '16px'
      }
    };
  });
};

var _default = useStyles;
exports.default = _default;